import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SERVER_API_URL} from 'app/app.constants';
import {ISpecialType, SpecialType} from 'app/blocks/model/special-type.model';
import {Resource} from 'app/constants/resource';
import {Observable} from 'rxjs';

import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class SpecialTypeService extends EntityCrudService<ISpecialType> {
    constructor(http: HttpClient) {
        super(http, Resource.SPECIAL_TYPES, (obj?) => new SpecialType(obj));
    }

    findAll = (): Promise<any> => {
        return this.http.get<SpecialType>(`${SERVER_API_URL}api/special-types`).toPromise();
    };

    getSpecialsForCustomerAndPoint(customerId: number, locationPointId: number): Promise<ISpecialType[]> {
        return this.http.get<SpecialType[]>(`${SERVER_API_URL}api/special-types/org/${customerId}/point/${locationPointId}`).toPromise();
    }
}
